module.exports = __webpack_public_path__ + "media/79_Long.64e87a80.mp3";